import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { usePathname, useSearchParams } from 'next/navigation';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import Stack from '@classify/react-core-components/Stack';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import { ROUTES, getPathName } from '@openclassrooms/routing';
import CareerIntentSvg from './images/career_intent.svg';
const Wrapper = styled('div')(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  margin: spacing(2, 0),
  [breakpoints.up('md')]: {
    margin: spacing(4, 0)
  }
}));
const BaseBlock = styled(Box)(({
  theme: {
    spacing,
    palette,
    breakpoints,
    radius
  }
}) => ({
  borderRadius: radius?.banner || 4,
  border: `solid 1px ${palette.layout.surface.border}`,
  padding: spacing(2),
  background: palette.layout.surface.alternativeBackground,
  [breakpoints.up('md')]: {
    padding: spacing(3, 4)
  }
}));
const ImageContainer = styled('div')(({
  theme: {
    breakpoints
  }
}) => ({
  display: 'none',
  [breakpoints.up('md')]: {
    display: 'block'
  }
}));
const CourseNeedLogin = () => {
  const $ = _c(12);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams?.toString() ? `?${searchParams.toString()}` : "";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentPathWithQuery = `${pathname}${t0}`;
  let t1;
  if ($[2] !== currentPathWithQuery) {
    t1 = new URLSearchParams({
      _target_path: currentPathWithQuery,
      context: "courseAccess"
    }).toString();
    $[2] = currentPathWithQuery;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const loginQuery = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ImageContainer><Image src={CareerIntentSvg} alt="" width={56} height={56} /></ImageContainer>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography component="div" variant="h6" sx={{
      marginBottom: 0.5
    }}>{translate("global.intro_visitor.welcome_oc.title")}</Typography>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography component="div" variant="subheadingSmall">{translate("global.intro_visitor.benefice_register.subheading")}</Typography>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getPathName(ROUTES.AUTH.LOGIN);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = `${t5}?${loginQuery}`;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      mr: "auto"
    };
    t8 = translate("global.intro_visitor.single_authentification_button");
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6) {
    t9 = <Wrapper><BaseBlock component="aside"><Stack gap={4} alignItems="center" direction="row">{t2}<Stack gap={1}>{t3}{t4}<Button variant="tertiary" component="a" href={t6} data-event="Navigation|Redirection::Internal|Authentication" sx={t7}>{t8}</Button></Stack></Stack></BaseBlock></Wrapper>;
    $[10] = t6;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};
export default CourseNeedLogin;